<div class="row">
  <div class="col-12">
    <div class="alert" [ngClass]="'alert-' + alertType" role="alert">
      <ng-content></ng-content>
    </div>
  </div>
</div>
